import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import {
  Card, Col, Form, Row,
} from 'react-bootstrap';

import FilterInputField from './FilterInputField';

class PaymentFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      conditions: Map({}),
    };
    this.onChangeFilter = this.onChangeFilter.bind(this);
  }

  onChangeFilter(field, condition) {
    let { conditions } = this.state;
    if (condition) {
      conditions = conditions.set(field, condition);
    } else {
      conditions = conditions.remove(field);
    }
    this.setState({ conditions });

    let query = '';
    conditions.mapEntries(([, value]) => {
      if (query === '') {
        query = `${value}`;
      } else {
        query = `${query} AND ${value}`;
      }
    });

    const { onChange } = this.props;
    onChange(query);
  }

  render() {
    return (
      <Card>
        <Card.Body>
          <Form>
            <Row style={{ padding: '5px' }}>
              <Col style={{ minWidth: '350px' }}>
                <FilterInputField
                  type="text"
                  field="paymentData.accountData.accountNumber"
                  text="Account Number"
                  onChange={(condition) => this.onChangeFilter('paymentData.accountData.accountNumber', condition)}
                />
              </Col>
              <Col style={{ minWidth: '350px' }}>
                <FilterInputField
                  type="text"
                  field="paymentData.accountData.client.name"
                  text="Client"
                  onChange={(condition) => this.onChangeFilter('paymentData.accountData.client.name', condition)}
                />
              </Col>
              <Col style={{ minWidth: '350px' }}>
                <FilterInputField
                  type="text"
                  field="tpsPaymentReceipt"
                  text="TPS Receipt"
                  onChange={(condition) => this.onChangeFilter('paymentData.tpsTransactionId', condition)}
                />
              </Col>
              <Col style={{ minWidth: '350px' }}>
                <FilterInputField
                  type="text"
                  field="processorTransactionId"
                  text="Processor ID"
                  onChange={(condition) => this.onChangeFilter('processorTransactionId', condition)}
                />
              </Col>
              <Col style={{ minWidth: '350px' }}>
                <FilterInputField
                  type="number"
                  field="paymentAmount"
                  text="Amount"
                  onChange={(condition) => this.onChangeFilter('paymentAmount', condition)}
                />
              </Col>
              <Col style={{ minWidth: '350px' }}>
                <FilterInputField
                  type="date"
                  field="dateTime"
                  text="Timestamp"
                  onChange={(condition) => this.onChangeFilter('dateTime', condition)}
                />
              </Col>
            </Row>
          </Form>
        </Card.Body>

      </Card>
    );
  }
}

PaymentFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default PaymentFilter;
